import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelCardList extends Layout {
    searchpanelFuelCard: SearchPanel;
    sourceFuelCardList: DataSource;
    tableFuelCardList: Table;
    textboxSearchAccountId: Textbox;
    textboxSearchCardNum: Textbox;
    textboxSearchCardProvider: Textbox;
    textboxSearchCardType: Textbox;
    textboxSearchDriver: Textbox;
    textboxSearchFuelExpenseid: Textbox;
    textboxSearchPayee: Textbox;
    textboxSearchStatus: Textbox;
    textboxSearchSubAccount: Textbox;
    textboxSearchTractorId: Textbox;
}
